import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    accentClassName?: string
}

interface LogoProps {
    className?: string
    markClassName?: string
    tone?: 'light' | 'dark'
}

/*
 * A stylized fundus: the retinal field, the optic disc, the two vascular
 * arcades that sweep around the macula, and the fovea as a warm accent.
 */
export const LogoMark: FC<LogoMarkProps> = ({ className, accentClassName }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            aria-hidden='true'
            className={cn('shrink-0', className)}
        >
            <circle cx='16' cy='16' r='14.2' stroke='currentColor' strokeWidth='1.6' />
            <circle cx='21.2' cy='15.4' r='2.75' fill='currentColor' />
            <path d='M19.1 13.8C15.9 10.2 11.6 10.1 8.2 11.9' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
            <path d='M19.1 17C15.9 20.6 11.6 20.7 8.2 18.9' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
            <circle cx='12.4' cy='15.4' r='1.25' className={cn('fill-terracotta', accentClassName)} />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markClassName, tone = 'light' }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-2.5',
                tone === 'light' ? 'text-chocolate' : 'text-ivory',
                className
            )}
        >
            <LogoMark
                className={cn('size-7', markClassName)}
                accentClassName={tone === 'light' ? 'fill-terracotta' : 'fill-gold'}
            />

            <span className='font-heading text-[1.6rem] leading-none tracking-[-0.01em]'>
                Ocuvia
            </span>
        </span>
    )
}
